/**
 * Defines theme types for the application
 */
import { ThemeTokens } from './tokens';

/**
 * Enum representing available theme modes
 */
export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

/**
 * Interface for theme state
 */
export interface ThemeState {
  /**
   * Current theme mode (light or dark)
   */
  mode: ThemeMode;

  /**
   * Current theme palette based on mode
   */
  colors: ThemeTokens;

  /**
   * Sets the theme mode
   */
  setThemeMode: (mode: ThemeMode) => void;
}
